import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal'
import CustomModal from './CustomModal';
import Style from '../Styles/DashboardStyle.module.css';
import { Link ,useNavigate} from 'react-router-dom';
import DashboardTitle from "./DashboardTitle";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DashBoardLeftProfileMenu from "./DashBoardLeftProfileMenu";
import { useSelector } from 'react-redux';
import { getUserBussinessListFormData ,getUserOffersListFormData,getOfferListIdFormData,getOfferDeleteFormData} from "../../services/routes.services";
import { IoMdClose } from "react-icons/io";
import constants from "../../services/constants";

const MyOffer = ()=>{
    const [show, setShow] = useState(false);
    const [getAllData, setGetAllData] = useState(null);
    const [getDetails, setDetails] = useState(null);
    const [offerData, setOfferData] = useState();
    const [modalOpen, setModalOpen] = useState(false);
    const [modalData, setModalData] = useState(false);

    const { isAuthenticated, user,token } = useSelector((state) => state.auth);
  
    useEffect(() => {
        getUserBussinessListFormData(token)
            .then((res) => {
                setGetAllData(res.data.business);
            })
            .catch((error) => {
                console.log(error);
            });
            getOffersDetails()
    }, []);
    const getOffersDetails=()=>{
        getUserOffersListFormData(token)
        .then((res) => {
            setOfferData(res.data.offers);
        })
        .catch((error) => {
            console.log(error);
        });
    }
    const navigate = useNavigate();
    const handleOpen = (data) => {
        setModalData(data)
      setModalOpen(true);
    };
  
    const handleDeleteClose = () => {
      setModalOpen(false);
    };
  
    const handleConfirm = (data) => {
        getOfferDeleteFormData(data._id,token)
      .then((res) => {
        console.log("res",res)
        if(res.status===200){
        toast.success(res.data.message, {
               position: "top-right",
                
            type: 'success'
        });
        getOffersDetails();
    }else{
        toast.error(res.data.message, {
            position: "top-right",
               type: 'error'
         });
    }
           })
      .catch((error) => {
          console.log(error);
      });
      setModalOpen(false);
    };
    const handleClose = () => setShow(false);
   
    const handleShow = (Busnisslist) => {
        setShow(true);
       
        getOfferListIdFormData(Busnisslist._id)
            .then((res) => {
                setDetails(res.data);
                    
            })
            .catch((error) => {
                console.log(error);
            });
            
            
    }
    const handleEditPage=(offerDetails)=>{
        navigate("/offer-create", { state: { offerDetails: offerDetails } });
    }
    return( 
        <div><DashBoardLeftProfileMenu/>
         <div className={'containerStyla  ' + Style.Dashboardscreen +" "+Style.BussinesList}>
            <Container>
                <DashboardTitle title="Offers Listing" membertype="Non Member" />
                <Row className={Style.space}>
                <Col lg={6} className={Style.order2}>      
                    <h3 className={Style.dashboardSubTitle}>YOUR OFFER LISTINGS</h3>
                    {offerData &&(<>
                {offerData.map((offerDetails)=>{
                    return(
                        <div className={Style.jobList} key={offerDetails._id}>
                           
                        <figure><img src={constants.IMAGE_BASE_URL+'business/'+offerDetails.image} /></figure>
                        {offerDetails.package && (<h4> {offerDetails.package}</h4>)}
                            {offerDetails.companyName && (<p> {offerDetails.companyName}</p>)}
                            {offerDetails.jobRole && (<span> {offerDetails.package}</span>)}
                        
                            <ul>
                                <li><a href="#" onClick={(e) => {e.preventDefault();handleShow(offerDetails)}} className={Style.discountBtn}>More Details</a></li>
                                <li><a href="#" onClick={(e) => {e.preventDefault();handleEditPage(offerDetails)}}>Edit</a></li>
                                <li><a href="#" onClick={(e) => {e.preventDefault();handleOpen(offerDetails)}}>Delete Listing</a>
                                        <CustomModal
                                            open={modalOpen}
                                            handleDeleteClose={handleDeleteClose}
                                            handleConfirm={()=>handleConfirm(modalData)}
                                            title="Confirm Action"
                                            offerData={modalData}
                                            description="Are you sure you want to perform this action?"
                                        />                          
                                            </li>
                            </ul>                    
                    </div> 
                    )
                }) }
                 </>)}
              
                </Col>
                <Col lg={6} className={Style.paddL + " " + Style.order1}>
                    <div className={Style.addJobList}>
                            <h4>Add New Offer</h4>
                            <Link to="/offer-create" className={Style.greenBtn} >Click Here</Link>
                        </div>
                </Col>
            </Row>
                {show &&
                    <div className={Style.popOverlay}>
                        <div className={Style.discountPopup}>
                            {console.log(getDetails,"getDetails")}
                            <button type="button" className={Style.closePopup} onClick={handleClose}><IoMdClose /></button>
                            {getDetails &&
                            <>
                                <div className={Style.discountDetails}>
                                    <div className={Style.companyLogo}>
                                        <img src={constants.IMAGE_BASE_URL+'business/'+getDetails.offer[0].image} />
                                    </div>
                                    <div className={Style.offerHead}>
                                        <h2>
                                            {getDetails.offer[0].package}
                                        </h2>
                                        
                                    </div>
                                    <div className={Style.offerDetails}>
                                        <table role="none">
                                            <tbody><tr>
                                                <td className={Style.left}>Business Name</td>
                                                <td className={Style.right}>{getDetails.companyName.name}</td>
                                            </tr>
                                            <tr>
                                                <td className={Style.left}>Category</td>
                                                <td className={Style.right}>{getDetails.offer[0].category}</td>
                                            </tr>
                                            
                                            <tr>
                                                <td className={Style.left}>Business Contact No.</td>
                                                <td className={Style.right}> {getDetails.offer[0].businessOfferContactNumber}</td>
                                            </tr>
                                            <tr>
                                                <td className={Style.left}>CITY</td>
                                                <td className={Style.right}>{getDetails.offer[0].city} </td>
                                            </tr>
                                             <tr>
                                                <td className={Style.left}>Description</td>
                                                <td className={Style.right}>{getDetails.offer[0].offerDescription}</td>
                                            </tr>
                                            <tr>
                                                <td className={Style.left}>Posted By Name</td>
                                                <td className={Style.right}>{getDetails.offer[0].alumniName}</td>
                                            </tr>
                                            <tr>
                                                <td className={Style.left}>Coupon Code</td>
                                                <td className={Style.right}>{getDetails.offer[0].couponCode}</td>
                                            </tr>
                                            <tr>
                                                <td className={Style.left}>Batch</td>
                                                <td className={Style.right}>{getDetails.offer[0].batch}</td>
                                            </tr>
                                        </tbody>
                                        </table>
                                    </div>
                                    {/* <a href="#" onClick={(e) => {e.preventDefault();handleEditPage(getDetails)}} className={Style.greenBtn}>Edit</a> */}
                                    </div>
                                
                                
                            {/* } */}
                            
                            </>
                            }  
                        </div>
                    </div>
                }
            <ToastContainer/>
            </Container>
        </div>
        </div>
        )
    }
    
    export default MyOffer;